import React from 'react'
import { Helmet } from 'react-helmet'
import NavBar from '../components/NavBar'
import Footer from '../components/Footer'
import './Careers.css'

const Careers = () => {
  return (
    <div className="careers-container">
      <Helmet>
        <title>Careers - Block Automation</title>
        <meta property="og:title" content="Careers - Block Automation" />
        <meta property="og:description" content="Join the Block Automation team and help revolutionize sunscreen distribution." />
      </Helmet>
      
      <NavBar />
      
      <div className="careers-hero-section section-container">
        <div className="max-width">
          <span className="beforeHeading">JOIN OUR TEAM</span>
          <h1 className="careers-title">Careers at Block Automation</h1>
          <p className="careers-subtitle">
            We solve build innovative, automated solutions in a sustainable way.
          </p>
        </div>
      </div>
      
      <div className="careers-content-section section-container">
        <div className="max-width">
          <div className="careers-message">
            <h2>We're Growing</h2>
            <p>
              While we're not actively hiring for specific roles at the moment, we're always 
              interested in connecting with talented individuals who are passionate about our mission.
            </p>
            <p>
              If you think you could be a great fit for Block Automation and want to be considered 
              for future opportunities, please drop us a message using the form below.
            </p>
          </div>
          
          <div className="careers-contact-form">
            <h3>Get in Touch</h3>
            <form>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input type="text" id="name" name="name" placeholder="Your name" required />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" name="email" placeholder="Your email" required />
              </div>
              
              <div className="form-group">
                <label htmlFor="resume">Resume/CV</label>
                <input type="file" id="resume" name="resume" />
                <small>Please upload your resume or CV (PDF format preferred)</small>
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Why do you want to work with us?</label>
                <textarea 
                  id="message" 
                  name="message" 
                  rows="5" 
                  placeholder="Tell us about your skills, experience, and why you're interested in Block Automation..."
                  required
                ></textarea>
              </div>
              
              <button type="submit" className="button button-primary">Submit Application</button>
            </form>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  )
}

export default Careers